import React from 'react';
import { Spacer, Text } from '@ontruck/orc';
import { FormatPrice } from 'utils/format';

const BidOffer = ({
  changes: { carrier_name_after, driver_name_after, currency, cost },
  ...props
}) => {
  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        {carrier_name_after}
      </Text>
      <Text color="grey800" display="block">
        {driver_name_after}
      </Text>
      <FormatPrice currency={currency} value={cost} />
    </Spacer>
  );
};

export default BidOffer;
